var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8568 24.4939C39.8568 23.9525 39.8346 23.4337 39.7901 22.8923L44.1002 19.5762C45.0222 18.8769 45.2777 17.5573 44.7 16.5196L40.3678 8.92877C40.0901 8.43249 39.6457 8.06028 39.1125 7.86853C38.5793 7.68807 38.0017 7.71062 37.4796 7.93621L32.503 10.0792C31.6477 9.47016 30.7479 8.92877 29.7926 8.4776L29.1261 3.05236C28.9928 1.87933 27.993 0.988281 26.8378 0.988281H18.2066C17.0291 0.988281 16.0293 1.87933 15.896 3.05236L15.2295 8.4776C14.2853 8.92877 13.3744 9.47016 12.5191 10.0792L7.54254 7.93621C6.47614 7.46248 5.232 7.89109 4.65437 8.92877L0.310996 16.5534C-0.266639 17.5911 -0.0111464 18.8769 0.910848 19.6101L5.20979 22.9261C5.10981 23.9864 5.10981 25.0466 5.20979 26.0956L0.910848 29.4116C-0.0111464 30.1109 -0.266639 31.4306 0.310996 32.4682L4.64326 40.0591C5.2209 41.0968 6.47614 41.5141 7.53144 41.0516L12.508 38.9086C13.3633 39.5177 14.2631 40.0591 15.2184 40.5102L15.8849 45.9355C16.0182 47.1085 17.018 47.9996 18.1733 47.9996H26.8045C27.9597 47.9996 28.9595 47.1085 29.0928 45.9355L29.7593 40.5102C30.7035 40.0591 31.6144 39.5177 32.4697 38.9086L37.4463 41.0516C38.5127 41.5254 39.7568 41.0968 40.3344 40.0591L44.6667 32.4682C45.2443 31.4306 44.9889 30.1448 44.0669 29.4116L39.7568 26.0956C39.8235 25.5542 39.8457 25.0353 39.8457 24.4939H39.8568ZM22.5944 32.7164C18.1288 32.7164 14.4964 29.0281 14.4964 24.4939C14.4964 19.9597 18.1288 16.2715 22.5944 16.2715C27.0599 16.2715 30.6924 19.9597 30.6924 24.4939C30.6924 29.0281 27.0599 32.7164 22.5944 32.7164Z",
    fill: "url(#paint0_linear_187_21415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_21415",
    x1: 45.2777,
    y1: -0.523118,
    x2: 2.22426,
    y2: 45.3259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4FEAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4abec66dd7d1abf0e1cc355161d41b12.svg";
export { ForwardRef as ReactComponent };